import React from "react";
import moment from "moment";
import { formatDate } from "../../../../utils/index.ts";

const ModalCheckDetails = ({
  partnerId,
  setShowModal,
  checkDetails,
  profileImage,
}: {
  partnerId: number;
  setShowModal: (_: boolean) => void;
  checkDetails: any;
  profileImage?: string;
}) => {

  const normalized = (() => {
    if (!checkDetails) return null;
    if (checkDetails.assistanceCheck || checkDetails.assistanceCheckOut) {
      return [
        checkDetails.assistanceCheck,
        checkDetails.assistanceCheckOut,
      ].filter(Boolean);
    }
    if (Array.isArray(checkDetails)) {
      return checkDetails;
    }
    return [checkDetails];
  })();


  return (
    <div>
      {!normalized || normalized.length === 0 ? (
        <div className="py-4 text-center">
          <h5 className="text-secondary">
            No se encontraron detalles de chequeo.
          </h5>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row g-3 align-items-stretch">
            <div className="col-12 col-md-4">
              <div className="card shadow-sm border-0 h-100">
                <div className="card-header bg-white d-flex justify-content-between align-items-center">
                  <span className="fw-bold">Colaborador</span>
                </div>
                <div className="card-body">
                  <div className="ratio ratio-4x3 mb-3">
                    <img
                      src={
                        profileImage ||
                        (checkDetails as any)?.profileImage ||
                        (checkDetails as any)?.partnerPhotoUrl ||
                        "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                      }
                      alt="Colaborador"
                      className="rounded w-100 h-100"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {normalized.map((item: any, idx: number) => {
              const title = idx === 0 ? "Entrada" : "Salida";
              const statusVariant =
                item?.status === "Asistencia"
                  ? "success"
                  : item?.status === "Retardo"
                  ? "warning"
                  : item?.status === "Salida"
                  ? "info"
                  : "secondary";
              return (
                <div className="col-12 col-md-4" key={idx}>
                  <div className="card shadow-sm border-0 h-100">
                    <div className="card-header bg-white d-flex justify-content-between align-items-center">
                      <span className="fw-bold">{title}</span>
                      <span className={`badge bg-${statusVariant}`}>
                        {item?.status || "-"}
                      </span>
                    </div>
                    <div className="card-body">
                      <div className="d-flex flex-column gap-3">
                        <div className="ratio ratio-4x3">
                          <img
                            src={
                              item?.photoUrl ||
                              "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png"
                            }
                            alt={`Foto ${title}`}
                            className="rounded w-100 h-100"
                            style={{ objectFit: "cover" }}
                          />
                        </div>
                        <div className="d-flex flex-wrap gap-2 align-items-center">
                          <div className="me-3">
                            <small className="text-muted d-block">Fecha</small>
                            <span className="fw-semibold">
                              {formatDate(item?.checkDate)}
                            </span>
                          </div>
                          <div className="me-3">
                            <small className="text-muted d-block">Hora</small>
                            <span className="fw-semibold">
                              {item?.checkTime || "-"}
                            </span>
                          </div>
                          {item?.code && (
                            <div className="me-3">
                              <small className="text-muted d-block">
                                Código usado
                              </small>
                              <span
                                className="badge bg-dark"
                                style={{ fontFamily: "monospace" }}
                              >
                                {item.code}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="row g-2">
                          {item?.deviceName && (
                            <div className="col-6">
                              <small className="text-muted d-block">
                                Dispositivo
                              </small>
                              <span className="fw-semibold">
                                {item.deviceName}
                              </span>
                            </div>
                          )}
                          {item?.deviceModel && (
                            <div className="col-6">
                              <small className="text-muted d-block">
                                Modelo
                              </small>
                              <span className="fw-semibold">
                                {item.deviceModel}
                              </span>
                            </div>
                          )}
                          {item?.ip && (
                            <div className="col-6">
                              <small className="text-muted d-block">IP</small>
                              <span className="fw-semibold">{item.ip}</span>
                            </div>
                          )}
                          {item?.location && (
                            <div className="col-6">
                              <small className="text-muted d-block">
                                Ubicación
                              </small>
                              <span className="fw-semibold">
                                {item.location}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalCheckDetails;
